// import { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { singles as sings, albums as als, imgUrl } from './modules/Arrays';
import { searchFor } from './modules/Functions';
import Track from "./Track";

const Search = () => {
    const { track } = useParams();
    const history = useHistory();
    const albums = searchFor(track, als);
    const singles = searchFor(track, sings);

    const albumContent = albums.map(song => (
        <Track 
            song={song} 
            key={song.id} 
            link={`/albums/${song.album.replace(/ /g,'-')}`} 
            img={imgUrl+"next.png"} 
            alt={`Go to ${ song.title }`}
            link_two={`/download/${song.id}-${song.title.replace(/ /g,'-')}`} 
            img_two={imgUrl+"dl.png"}
            alt_two={`Download ${ song.title }`}
        />
    ));

    const singleContent = singles.map(single => (
        <Track 
            song={single} 
            key={single.id} 
            link={`/singles/${single.title.replace(/ /g,'-')}`} 
            img={imgUrl+"next.png"} 
            alt={`Go to ${ single.title }`}
        />
    ));


    return(
        <div className="musicals">
            <button onClick={history.goBack}>Back</button>
            { albums.length > 0 && <>
                <h4>Search Result from Albums</h4>
                <div className="grid-4">
                    { albumContent }
                </div>
            </>}
            { singles.length > 0 && <>
                <h4>Search Result from Singles</h4>
                <div className="grid-4">
                    { singleContent }
                </div>
            </>}
            { (albums.length === 0 && singles.length === 0) && <>
                <h3>Sorry, Your search for {track} turned up nothing</h3>
            </> }
        </div>
    )
    
}

export default Search;